export default "__VITE_PUBLIC_ASSET__4b1aa227__"